/// <reference path="../../../../../../typings/index.d.ts" />
angular.module('ApptBookApp').factory('AuthInterceptor', ['$location', $location => ({
	request(config) {
		config.headers = config.headers || {};
		const token = sessionStorage.getItem('sessionId');
		if (token) {
			config.headers.Authorization = `Basic ${token}`;
		}
		return config;
	},
	responseError(rejection) {
		if (rejection.status === 401) {
			$location.path('#login');
		}
		return rejection;
	}
})]);

module Meevo.Plugins.AppointmentBook.Models {
	export interface WarningList extends Array<Warning> {
	}

	export class Warning implements Meevo.Plugins.AppointmentBook.Services.ModalMessage {
		message: string;

		getMessage() { return this.message; }
	}


	export class AppointmentBookFilters {
		dimensionDates: Array<DimensionDate> = [];
		displayNoShows: boolean = false;
	}

	export class DimensionDate {
		date: Date;
		entityId: Guid;
	}

	export class EmployeeDimensionDate implements DimensionDate {
		date: Date;
		entityId: Guid;
		isShared: boolean;
		managedByLocationId: number;
	}

	export interface IRestServer {
		//used from BlockService:
		getAppointBlock(blockId: string, onSuccess: (resp: any) => void);
		saveAppointBlock(block: Block, onSuccess: (resp: any) => void);
		deleteLock(blockId: string, lockType: string);
		LoadFilteredEmployees(filter: any): ng.IPromise<any>;
		LoadFilteredBlockTypes(filter: any): ng.IPromise<any>;

	}
}

angular.module('ApptBookApp').factory('restServer', [
	'$rootScope',
    '$http',
    '$translate',
	'meevo.components.busy.BusyService',
	'meevo.components.modal.ModalService',
	'meevo.AppSettings',
	(
		$rootScope,
        $http: ng.IHttpService,
        $translate: angular.translate.ITranslateService,
		busyService: Meevo.Components.Busy.IBusyService,
		modalService: Meevo.Components.Modal.IModalService,
		appSettings: Meevo.Components.Common.IAppSettings
	) => {
		var restServer: any = {};
		//var subdomain = localStorage.getItem('subdomain');
		//var employeeId = localStorage.getItem('employeeGlobalId');

		var baseUrl = (sessionStorage.getItem('BASE_URL') || '') + '/api/';

		function getUrl(subUrl: any) {
			return baseUrl + subUrl;
		}

		var patchAppointment = (appointmentId: Meevo.Guid, entityVersion: number, model: any): ng.IHttpPromise<any> => {
			const url = getUrl(`Appointment/${appointmentId}`);
			return $http({
				url: url,
				method: 'PATCH',
				data:
				{
					Id: appointmentId,
					EntityVersion: entityVersion,
					Model: model,
					AsLocationId: restServer.asLocationId,
					locale: appSettings.APP_COUNTRYID,
					timeFormat: appSettings.APP_TIME_FORMAT
				}
			});
		}

		var createAppointmentServicePatchRequest = (appointmentEntityVersion: number, suppressWarnings: boolean, patchAsCopy: boolean, model: any) => {
			return {
				AppointmentEntityVersion: appointmentEntityVersion,
				Model: model,
				SuppressWarnings: suppressWarnings,
				PatchAsCopy: patchAsCopy,
				AsLocationId: restServer.asLocationId,
				locale: appSettings.APP_COUNTRYID,
				timeFormat: appSettings.APP_TIME_FORMAT
			};
		}

		var patchAppointmentServiceData = (appointmentServiceId: Meevo.Guid, appointmentId: Meevo.Guid, data: any): ng.IHttpPromise<any> => {

			const url = getUrl(`Appointment/${appointmentId}/AppointmentService/${appointmentServiceId}`);
			return $http({
				url: url,
				method: 'PATCH',
				data: data
			});
		}

		var patchAppointmentServiceListData = (appointmentId: Meevo.Guid, data: any): ng.IHttpPromise<any> => {

			const url = getUrl(`Appointment/${appointmentId}/AppointmentServiceCheckIn/List`);
			return $http({
				url: url,
				method: 'PATCH',
				data: data
			});
		}

		var patchAppointmentServiceCheckout = (appointmentServiceId: Meevo.Guid, appointmentId: Meevo.Guid, appointmentEntityVersion: number,
			suppressWarnings: boolean, patchAsCopy: boolean, model: any): ng.IHttpPromise<any> => {

			const url = getUrl(`Appointment/${appointmentId}/AppointmentServiceCheckout/${appointmentServiceId}`);
			return $http({
				url: url,
				method: 'PATCH',
				data:
				{
					AppointmentEntityVersion: appointmentEntityVersion,
					Model: model,
					SuppressWarnings: suppressWarnings,
					PatchAsCopy: patchAsCopy,
					AsLocationId: restServer.asLocationId
				}
			});
		}

		var handleMultipleChoiceResponse = (responseData: any, onMultipleChoice: any, preProcessCustomState: any = undefined) => {

            if (!onMultipleChoice ||
                !responseData ||
                !responseData.responseStatus ||
                !responseData.responseStatus.meta ||
                !responseData.responseStatus.meta["YesFlag"] ||
                !responseData.responseStatus.meta["NoFlag"]) {
				return false; // response not handled
			}

			const isRetryNeeded = (isYesResult: boolean) => (request) => {
				busyService.start();
				request[responseData.responseStatus.meta[isYesResult ? "YesFlag" : "NoFlag"]] = true;
				return true;
			};

			const getMultipleChoiceResponse = (response: Meevo.Model.MessageBoxButtonResult) => {
				return responseData.responseStatus.meta[response === Meevo.Model.MessageBoxButtonResult.Yes ? "YesFlag" : "NoFlag"];
            };

            let customState = responseData.responseStatus.meta['CustomState'];
            if (customState) {
                customState = JSON.parse(customState);
                if (preProcessCustomState) {
                    customState = preProcessCustomState(customState);
                }
            }

			const options: Meevo.Components.Modal.IModalOptions = {
				templateUrl: "app/plugins/AppointmentBook/views/Message.html",
				controller: "meevo.plugins.appointmentBook.MessageController",
				controllerAs: "vm",
				bindToController: true,
				multiple: true,
				skipHide: true,
				onComplete: undefined,
				locals: {
                    message: responseData.responseStatus.message,
                    customState: customState,
					config: {
						buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
						callback: (result) => onMultipleChoice(isRetryNeeded(result === Meevo.Model.MessageBoxButtonResult.Yes), getMultipleChoiceResponse(result))
					}
				}
			}

			modalService.showCustom(options, Meevo.Components.Modal.ModalTranslationModes.Translate).then((result) => {
				if (result && result.callback) {
					result.callback(result.result, result.callbackParam);
				};
			});

			// response handled
			return true;
		}

		restServer.asLocationId = null;

		restServer.SetOnSuccessAndError = (
            promise: ng.IHttpPromise<any>,
            onSuccess,
            extraData,
			onWarning: ng.IHttpPromiseCallback<Meevo.Plugins.AppointmentBook.Models.WarningList>,
            onFailure: any,
            onMultipleChoice: any,
			preProcessCustomState: any = undefined
        ) => {
			var cb = (data, status: number, headers, config) => {
				busyService.stop();
				var ok = (status - 200) >= 0 && (status - 200) < 100;
				if (ok) {
					if (onSuccess) {
						onSuccess(data, extraData);
					}
					return;
				}

				if (status === 409 /*conflict means warning!*/ && onWarning != null) {
					data.isWarning = true;
					onWarning(<Meevo.Plugins.AppointmentBook.Models.WarningList>data.responseStatus.errors, status, headers, config);
					return;
                }
                else if (status === 412 || status === 410) {
                    // let general exception interceptor handle 412
                    if (status === 410) {
                        $rootScope.$broadcast(Meevo.Components.Common.Messages.SERVER_VALIDATION,data.responseStatus.message,Meevo.Model.NotificationModeType.Modal,
                            true);
                    }
                    if (onFailure) {
						onFailure();
					}
					return;
				}
				else if (status === 422 || status === 500) {
					// validation failure as well as unhandled exception message broadcast already taken care of by interceptor
					if (onFailure) {
						onFailure(data);
					}
					return;
				}
				else if (status === 300 && handleMultipleChoiceResponse(data, onMultipleChoice, preProcessCustomState)) {
					return;
				}

				if (data && data.hasOwnProperty("responseStatus")) {
					$rootScope.$broadcast("serverError", data.responseStatus);
				} else {
					$rootScope.$broadcast("serverError", {
                        "errorCode": status,
                        "message": data,
                        "stackTrace": ""
                    });
				}
			};

			promise.success(cb);
			promise.error(cb);
			return promise;
		}


		restServer.loadEmployeeCounts = (startDateTime, endDateTime, increment) => {

			var request = {
				'StartDateTime': startDateTime,
				'EndDateTime': endDateTime,
				'Increment': increment
			};

			const url = getUrl('/AppointmentBook/AvailableEmployeeCount/List');

			return $http.post(url, request);
		}

		restServer.loadResourceCounts = (startDateTime, endDateTime, increment, resourceCatId = null) => {
			var request = {
				'StartDateTime': startDateTime,
				'EndDateTime': endDateTime,
				'Increment': increment,
				resourceCatId: resourceCatId
			};

			const url = getUrl('/AppointmentBook/AvailableResourceUnitCount/List ');

			return $http.post(url, request);
		}

        restServer.LoadAppointmentBookStructure = (isEmployeeView, dates, employeeCategoryIds, employeeIds, serviceIds, resourceIds, includeNoShows, priceLevels, showInCascadeMode?: boolean, columnHeaderOrder?: string[], gender?: number, isPrecisionView?: boolean) => {
			for (var i = 0; i < dates.length; i++) {
				dates[i] = moment(dates[i]).startOf('day').format();
			}

			var request = {
				'EmployeeIds': employeeIds,
				'ServiceIds': serviceIds,
				'EmployeeCategoryIds': employeeCategoryIds,
				'ResourceIds': resourceIds,
				'Dates': dates,
				'ColumnHeaderOrder': columnHeaderOrder,
				'IncludeNoShows': includeNoShows,
				'AsLocationId': restServer.asLocationId,
                'PriceLevels': priceLevels,
                'Gender': gender,
                'IsPrecisionTiming': isPrecisionView
			};

			let url = getUrl('AppointmentBook/ResourceDimension/List');
			if (isEmployeeView) {
				url = getUrl('AppointmentBook/EmployeeDimension/List');
				request['showInCascadeView'] = showInCascadeMode;
			}

			const promise = $http.post(url, request);
			return promise;
		}

		restServer.LoadAppointmentBookData = (isEmployeeView, filters: Meevo.Plugins.AppointmentBook.Models.AppointmentBookFilters, onSuccess, includeFilterData = false) => {
			let url = isEmployeeView
				? getUrl('AppointmentBook/EmployeeDimensionData/List')
			    : getUrl('AppointmentBook/ResourceDimensionData/List');

			let data: any = {
				'DimensionDates': filters.dimensionDates,
				'DisplayNoShows': filters.displayNoShows,
				'AsLocationId': restServer.asLocationId,
				'IncludeFilterData': includeFilterData,
            }

			const promise = $http.post(url, data);

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.LoadAppointmentBookDetailPopup = (appointmentServiceId, onSuccess, parentColumn) => {
			const url = getUrl(`AppointmentService/${appointmentServiceId}`);

            // includeOffers: Checkout hands this object to the Register, which applies the appointment's offer from appliedOffers.
            // No popup save sends this object back, which matters because the appointment merge proc inserts every offer it is sent.
            const request = {
                asLocationId: restServer.asLocationId,
                includeSteps: true,
                includeOffers: true,
            };

			const promise = $http.post(url, request);

			return restServer.SetOnSuccessAndError(promise, onSuccess, parentColumn);
		}

		restServer.LoadAppointmentBookBlockPopup = (blockId, onSuccess, parentColumn) => {
			const url = getUrl(`Block/${blockId}`);

			const promise = $http.post(url, { asLocationId: restServer.asLocationId });

			return restServer.SetOnSuccessAndError(promise, onSuccess, parentColumn);
		}

        restServer.loadScheduleTimeClockActions = (scheduleKeys, includeCompletedSchedules) => {
            var data: any = {
                'ScheduleKeys': scheduleKeys,
                'includeCompletedSchedules': includeCompletedSchedules
            }
            const url = getUrl('AppointmentBook/ScheduleTimeClockActionSet/List');

            const promise = $http.post(url, data);

            return promise;
        }
		restServer.LoadMembershipDetails = (clientIds) => {
			var data: any = {
				'ClientIds': clientIds,
				'AsLocationId': restServer.asLocationId
			}
			const url = getUrl('Membership/Client/StatusIndicator/List');

			const promise = $http.post(url, data);

			return promise;
        }

        restServer.loadYieldManagementList = (requestItems, filteredProgramId) => {
            var data: any = {
                'EmployeeDates': requestItems,
                'FilteredProgramId': filteredProgramId
            }
            const url = getUrl('AppointmentBook/YieldManagement/List');

            const promise = $http.post(url, data);

            return promise;
        }

        restServer.loadWalkinStatus = (appointmentServiceIds) => {
            var data: any = {
                'appointmentServiceIds': appointmentServiceIds
            }
            const url = getUrl('WalkinAppointment/WalkinStatus/List');

            const promise = $http.post(url, data);

            return promise;
        }

        restServer.LoadDaysBeforeBookingIsAllowed = () => {
            const url = getUrl('SecurityRole/DaysBeforeBookingIsAllowed');

            const promise = $http.get(url);

            return promise;
        }

		restServer.MoveAppointmentService = (appointmentServiceId, appointmentId, appointmentEntityVersion, date, time, employeeId, resourceUnitId, resourceId, autoAssignResources, suppressWarnings, onSuccess, onWarning: (any) => void, onFailure, fromDragAndDrop: boolean = false) => {
			var startDateTime;
			if (moment.isMoment(date)) {
				startDateTime = date.format();
			} else {
				startDateTime = moment(date + time, "M-DD-YYYYh:m").format();
			}

			var appointmentServicePatchModel: any = createAppointmentServicePatchRequest(appointmentEntityVersion, suppressWarnings, false, {
				StartDateTime: startDateTime,
				EmployeeId: employeeId,
				ResourceUnitId: resourceUnitId,
				ResourceId: resourceId
			});

			appointmentServicePatchModel.autoAssignResources = autoAssignResources;

			var doMove = () => patchAppointmentServiceData(appointmentServiceId, appointmentId, appointmentServicePatchModel);

			var onMultipleChoice = (isRetryNeeded, multipleChoiceResponse) => {
				if (isRetryNeeded(appointmentServicePatchModel)) {
					restServer.SetOnSuccessAndError(doMove(), onSuccess, { multipleChoiceResponse: multipleChoiceResponse, fromDragAndDrop: fromDragAndDrop }, onWarning, onFailure, onMultipleChoice);
				}
			};

			restServer.SetOnSuccessAndError(doMove(), onSuccess, { fromDragAndDrop: fromDragAndDrop }, onWarning, onFailure, onMultipleChoice);
		}

        restServer.CopyAppointmentService = (appointmentServiceId, appointmentId, appointmentEntityVersion, date, time, employeeId, resourceUnitId, resourceId, autoAssignResources, suppressWarnings, onSuccess, onWarning: (any) => void, onFailure) => {
			var startDateTime;
			if (moment.isMoment(date)) {
				startDateTime = date.format();
			} else {
				startDateTime = moment(date + time, "M-DD-YYYYh:m").format();
			}

			var appointmentServicePatchModel: any = createAppointmentServicePatchRequest(appointmentEntityVersion, suppressWarnings, true, {
				StartDateTime: startDateTime,
				EmployeeId: employeeId,
				ResourceUnitId: resourceUnitId,
				ResourceId: resourceId
			});
            appointmentServicePatchModel.autoAssignResources = autoAssignResources;

			var doCopy = () => patchAppointmentServiceData(appointmentServiceId, appointmentId, appointmentServicePatchModel);

			var onMultipleChoice = (isRetryNeeded, multipleChoiceResponse) => {
				if (isRetryNeeded(appointmentServicePatchModel)) {
					restServer.SetOnSuccessAndError(doCopy(), onSuccess, { appointmentServiceId: appointmentServiceId, multipleChoiceResponse: multipleChoiceResponse }, onWarning, onFailure, onMultipleChoice);
				}
			};

			restServer.SetOnSuccessAndError(doCopy(), onSuccess, { appointmentServiceId: appointmentServiceId }, onWarning, onFailure, onMultipleChoice);
		}

		restServer.CopyAppointBlock = (blockId, blockEntityVersion, date, time, employeeId, resourceUnitId, resourceId, suppressWarnings, onSuccess, onWarning: (any) => void, onFailure) => {
			var startDateTime;
			if (moment.isMoment(date)) {
				startDateTime = date.format();
			} else {
				startDateTime = moment(date + time, "M-DD-YYYYh:m").format();
			}

			const url = getUrl(`Block/${blockId}`);

			const options = {
				params: {
					locale: appSettings.APP_COUNTRYID,
					timeFormat: appSettings.APP_TIME_FORMAT
				}
			};

			var blockPatchModel = {
				EntityVersion: blockEntityVersion,
				Model: {
					StartDateTime: startDateTime,
					EmployeeId: employeeId,
					ResourceUnitId: resourceUnitId,
					ResourceId: resourceId,
					LocationId: 0
				},
				SuppressWarnings: suppressWarnings,
				PatchAsCopy: true,
				AsLocationId: restServer.asLocationId
			}

			const promise = $http.patch(url, blockPatchModel, options);

			restServer.SetOnSuccessAndError(promise, onSuccess, null, onWarning, onFailure);
		}

		restServer.MoveAppointBlock = (blockId, entityVersion, date, time, employeeId, resourceId, suppressWarnings: boolean, onSuccess, onWarning, onFailure) => {
			const url = getUrl(`Block/${blockId}`);

			const options = {
				params: {
					locale: appSettings.APP_COUNTRYID,
					timeFormat: appSettings.APP_TIME_FORMAT
				}
			};

			const promise = $http.patch(url,
				{
					id: blockId, //not really necessary as servicestack will populate this from the url
					entityVersion: entityVersion,
					model: {
						startDateTime: moment(date + time, "M-DD-YYYYh:m").format(),
						employeeId: employeeId,
						resourceId: resourceId
					},
					suppressWarnings: suppressWarnings,
					asLocationId: restServer.asLocationId
				}, options);

			restServer.SetOnSuccessAndError(promise, onSuccess, null, onWarning, onFailure);
		}

		restServer.LoadBusinessInfo = () => {
			const url = getUrl('Tenant/BusinessInfo/Location');

			const promise = $http.post(url,
				{
					asLocationId: restServer.asLocationId
				});

			return promise;
		}

		restServer.LoadBusinessInfoSettings = () => {
			const url = getUrl('Tenant/BusinessInfo/Settings');

			const promise = $http.get(url,
				{
					params: {
						asLocationId: restServer.asLocationId
					}
				});

			return promise;
		}

        restServer.loadWorkTypes = () => {
            const url = getUrl('workActivity/List');

            const promise = $http.post(url,
                {
                    criteria: {
                        includeActive: true,
                        includeInactive: true,
                        includeDeleted: true
                    },
                    pageNumber: 0,
                    itemsPerPage:10000
                });

            return promise;
        }

		restServer.LoadAppointmentBookInfoSettings = () => {
			const url = getUrl('Settings/AppointmentBook');

			const promise = $http.get(url, {});

			return promise;
		}

		restServer.LoadNotificationSettings = () => {
			const url = getUrl('notificationSetting');

			const promise = $http.get(url, null);

			return promise;
		}

        restServer.sendAppointmentNotification = (appointmentId, communicationMethod, communicationType, confirmState, entityVersion, onSuccess) => {
			const url = getUrl(`Appointment/${appointmentId}/Notification`);
			const promise = $http.post(url, {
				id: appointmentId,
				communicationMethod: communicationMethod,
				communicationType: communicationType,
				confirmState: confirmState,
                entityVersion: entityVersion
			});
			restServer.SetOnSuccessAndError(promise, onSuccess);

		}

		restServer.addContactAttempt = (appointmentId, onSuccess) => {
			const url = getUrl(`Appointment/${appointmentId}/ContactAttempt`);
			const promise = $http.post(url, {});
			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.LoadFilteredServices = (filter, page, pageSize) => {
			const url = getUrl('Service/List');
			return $http.get(url,
				{
					params: {
						filter: filter,
						pageNumber: page,
						pageSize: pageSize
					}
				});
		}

		restServer.LoadFilteredBlockTypes = filter => {
			const url = getUrl('AppointmentBook/BlockTypes');
			return $http.get(url,
				{
					params: {
						filter: filter
					}
				});
		}


		restServer.LoadFilteredAppointCats = (filter, page, pageSize) => {
			const url = getUrl('AppointmentBook/AppointCats');
			return $http.get(url,
				{
					params: {
						filter: filter,
						pageNumber: page,
						pageSize: pageSize
					}
				});
		}

		restServer.LoadAppointReasons = (filter, page, pageSize) => {
			const url = getUrl('CancellationType/List');
			return $http.get(url,
				{
					params: {
						filter: filter,
						pageNumber: page,
						pageSize: pageSize
					}
				});

		}

		restServer.LoadAppointReasonDetail = id => {
			const url = getUrl(`CancellationType/${id}`);
			return $http.get(url);
		}



		restServer.LoadFilteredEmployees = (filter, page, pageSize) => {
			const url = getUrl('Employee/List');
			return $http.get(url,
				{
					params: {
						filter: filter,
						pageNumber: page,
						pageSize: pageSize
					}
				});
		}

		restServer.LoadFilteredJobFunctions = (filter, page, pageSize) => {
			const url = getUrl('JobFunction/List');
			return $http.get(url,
				{
					params: {
						filter: filter,
						pageNumber: page,
						pageSize: pageSize
					}
				});
		}


		restServer.LoadFilteredClients = (filter, page, pageSize) => {
			const url = getUrl('Client/List');
			return $http.get(url,
				{
					params: {
						filter: filter,
						pageNumber: page,
						pageSize: pageSize
					}
				});
		}

		restServer.deleteAppointBlock = (blockId, entityVersion, onSuccess) => {
			const url = getUrl(`Block/${blockId}`);

			const promise = $http.delete(url, {
				params: {
					id: blockId,
					entityVersion: entityVersion,
					asLocationId: restServer.asLocationId,
					locale: appSettings.APP_COUNTRYID,
					timeFormat: appSettings.APP_TIME_FORMAT
				}
			});
			restServer.SetOnSuccessAndError(promise, onSuccess);
			return promise;
		}

		restServer.deleteBlockSchedule = (id, entityVersion, onSuccess) => {
			const url = getUrl(`BlockSchedule/${id}`);
			const promise = $http.delete(url,
				{
					params: {
						id: id,
						entityVersion: entityVersion
					}
				});
			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.deleteAppointStandingAppointment = (appointmentScheduleId, entityVersion, onSuccess) => {
            const url = getUrl(`AppointmentSchedule/${appointmentScheduleId}`);
			const promise = $http.delete(url,
				{
					params: {
                        id: appointmentScheduleId,
						entityVersion: entityVersion
					}
				});
			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

        restServer.confirmAppointment = (appointmentId: Meevo.Guid, entityVersion: number, onSuccess) => {
            const promise = patchAppointment(appointmentId, entityVersion, { "ConfirmState": Meevo.Model.ConfirmStateEnum.Confirmed, "CommunicationMethod": Meevo.Model.CommunicationMethodEnum.None });

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.unConfirmAppointment = (appointmentId: Meevo.Guid, entityVersion: number, onSuccess) => {
            const promise = patchAppointment(appointmentId, entityVersion, { "ConfirmState": Meevo.Model.ConfirmStateEnum.Unconfirmed, "CommunicationMethod": Meevo.Model.CommunicationMethodEnum.None });

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.changeAppointmentConfirmState = (appointmentId: Meevo.Guid, entityVersion: number, confirmState, onSuccess) => {
			const promise = patchAppointment(appointmentId, entityVersion, { "ConfirmState": confirmState });

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.changeAppointmentServiceState = (appointmentServiceId: Meevo.Guid, appointmentId: Meevo.Guid,
			appointmentEntityVersion: number, newState, startDateTime, onSuccess, onWarning: (any) => void,
			suppressWarnings: boolean, updateAppointmentOverlays = true) => {

			let data = createAppointmentServicePatchRequest(appointmentEntityVersion, suppressWarnings, false, {
				TransitionState: newState,
				StartDateTime: startDateTime
			});

			const promise = patchAppointmentServiceData(appointmentServiceId, appointmentId, data);

			return restServer.SetOnSuccessAndError(promise, onSuccess, updateAppointmentOverlays, onWarning);
		}

		restServer.changeAppointmentServiceListState = (appointmentServiceId: Meevo.Guid, appointmentId: Meevo.Guid, appointmentEntityVersion: number, newState, onSuccess) => {

			let data = createAppointmentServicePatchRequest(appointmentEntityVersion, true, false, {
				TransitionState: newState
			});

			const promise = patchAppointmentServiceListData(appointmentId, data);

			return restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.changeAppointmentServiceFinalState = (appointmentServiceId: Meevo.Guid, appointmentId: Meevo.Guid, appointmentEntityVersion: number, transitionState, newFinalState, onSuccess) => {

			const promise = patchAppointmentServiceCheckout(appointmentServiceId, appointmentId, appointmentEntityVersion, true, false,
				{
					TransitionState: transitionState,
					FinalState: newFinalState
				});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.updateCheckedOutService = (
            appointmentServiceId: Meevo.Guid,
            steps: any[],
            employeeType: Meevo.Model.EmployeeTypeEnum,
            bookingType: Meevo.Model.BookingTypeEnum,
            reBookingType: Meevo.Model.ReBookingTypeEnum,
            appointmentId: Meevo.Guid,
            appointmentEntityVersion: number,
            suppressWarnings: boolean,
            isCheckedOutUpdate: boolean,
            onSuccess,
            onWarning,
            preProcessCustomState: any = undefined
        ) => {
            let request: any = createAppointmentServicePatchRequest(appointmentEntityVersion, suppressWarnings, false, {
                employeeType: employeeType,
                bookingType: bookingType,
                reBookingType: reBookingType,
            });
            request.isCheckedOutUpdate = isCheckedOutUpdate;
            request.steps = steps;

			const callService = () => {
                const url = getUrl(`Appointment/${appointmentId}/AppointmentServiceSteps/${appointmentServiceId}`);
                return $http({
				    url: url,
				    method: 'PATCH',
				    data: request
                });
            };

			const onMultipleChoice = (isRetryNeeded, multipleChoiceResponse) => {
				if (isRetryNeeded(request)) {
                    const extraData = {
                        multipleChoiceResponse: multipleChoiceResponse,
                        request: request,
                    };
					restServer.SetOnSuccessAndError(callService(), onSuccess, extraData, onWarning, null, onMultipleChoice, preProcessCustomState);
				}
			};

			restServer.SetOnSuccessAndError(callService(), onSuccess, null, onWarning, null, onMultipleChoice, preProcessCustomState);
		}

		restServer.saveAppointBlockDefinition = (data, onSuccess) => {

			const url = getUrl(`BlockSchedule/${data.appointBlockDefinitionId}`);
			const promise = $http.post(url, data);
			restServer.SetOnSuccessAndError(promise, onSuccess);

		}

		restServer.getAppointmentServiceTemplateWithAddOns = (employeeId, serviceId, clientId, serviceAddOnIds, startDateTime, onSuccess: (...args: any[]) => any) => {
			const url = getUrl('AppointmentService/Template');
			if (startDateTime && isNaN(startDateTime.getTime())) {
				startDateTime = undefined;
			}
			const promise = $http.post(url,
				{
					ServiceId: serviceId,
					EmployeeId: employeeId,
					ServiceAddOnIds: serviceAddOnIds,
                    StartDateTime: startDateTime,
                    ClientId: clientId
				});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}
		restServer.getAppointmentServiceTemplate = (employeeId, serviceId, startDateTime, onSuccess) => {
			const url = getUrl('AppointmentService/Template');
			const promise = $http.post(url,
				{
					ServiceId: serviceId,
					EmployeeId: employeeId,
					StartDateTime: startDateTime,
					ServiceAddOnIds: null
				});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getMultipleAppointmentServiceTemplate = (employeeId, serviceId, startDateTime) => {
			const url = getUrl('AppointmentService/Template');

			const promise = $http.post(url,
				{
					ServiceId: serviceId,
					EmployeeId: employeeId,
					StartDateTime: startDateTime,
					ServiceAddOnIds: null
				});

			return promise;
		}

		restServer.saveAppointHeader = (appointHeader: Meevo.Model.Appointment, onSuccess, onWarning, employeeChanged, resourceChanged, onFailure) => {
			var doSave: any;
			appointHeader.asLocationId = restServer.asLocationId;
			appointHeader.locale = appSettings.APP_COUNTRYID;
			appointHeader.timeFormat = appSettings.APP_TIME_FORMAT;

			if (appointHeader.id == null) {
				const url = getUrl('Appointment');
				doSave = () => $http.post(url, appointHeader);
			} else {
				const url = getUrl(`Appointment/${appointHeader.id}`);
				doSave = () => $http.put(url, appointHeader);
			}

			var onMultipleChoice = (isRetryNeeded, multipleChoiceResponse) => {
				if (isRetryNeeded(appointHeader)) {
					restServer.SetOnSuccessAndError(doSave(), onSuccess, { multipleChoiceResponse: multipleChoiceResponse }, onWarning, null, onMultipleChoice);
				}
			};

			restServer.SetOnSuccessAndError(doSave(), onSuccess, { employeeChanged, resourceChanged }, onWarning, onFailure, onMultipleChoice);
		}

		restServer.saveAppointBlock = (block: Meevo.Plugins.AppointmentBook.Block, onSuccess, onWarning) => {
			let promise: ng.IPromise<any>;
			let url: string;

			block.asLocationId = restServer.asLocationId;

			const options = {
				params: {
					locale: appSettings.APP_COUNTRYID,
					timeFormat: appSettings.APP_TIME_FORMAT
				}
			};

			if (block.id) {
				url = getUrl(`Block/${block.id}`);
				promise = $http.put(url, block, options);
			} else {
				url = getUrl('Block');
				promise = $http.post(url, block, options);
			}

			restServer.SetOnSuccessAndError(promise, onSuccess, null, onWarning);
			return promise;
		}

		restServer.getAppointBlock = (blockId, onSuccess) => {
			const url = getUrl(`Block/${blockId}`);

			const promise = $http.post(url, { asLocationId: restServer.asLocationId });

			restServer.SetOnSuccessAndError(promise, onSuccess);
			return promise;
		}


		restServer.getAppointBlockDefinition = (appointBlockDefinitionId, onSuccess) => {
			const url = getUrl(`BlockSchedule/${appointBlockDefinitionId}`);

			const promise = $http.get(url,
				{
					params: {
						AppointBlockDefinitionId: appointBlockDefinitionId
					}
				});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getAppointment = (appointmentId, returnClient: boolean = false, includeFinalizedServices: boolean = false, verifyHasServiceAddOn: boolean = false) => {
			const url = getUrl(`Appointment/${appointmentId}`);

			return $http.get(url, {
				params: {
					returnClientData: returnClient,
					includeFinalizedServices: includeFinalizedServices,
					asLocationId: restServer.asLocationId,
					verifyHasServiceAddOn: verifyHasServiceAddOn
				}
			});
		}

		restServer.getConfirmationHistory = (appointmentId, locale) => {
			const url = getUrl(`Appointment/${appointmentId}/ConfirmationHistory`);

			let options = {};

			if (locale) {
				options = {
					params: {
						locale
					}
				};
			}

			return $http.get(url, options);
		}

		restServer.getFutureAppointments = clientId => {
			const url = getUrl('AppointmentBook/FutureAppointments');

			return $http.get(url, {
				params: {
					ClientId: clientId
				}
			});
		}

		restServer.getVisitNoteTypes = onSuccess => {
			const url = getUrl('VisitNoteType/List');

			const promise = $http.get(url, {
				params: {
					criteria: {}
				}
			});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getClient = (clientId, onSuccess) => {
			const url = getUrl('AppointmentBook/FullClient');

			const promise = $http.get(url,
				{
					params: {
						ClientId: clientId
					}
				});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getClientTypes = (clientId, onSuccess) => {
			const url = getUrl(`client/${clientId}/ClientTypes`);

			const promise = $http.get(url, {});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.saveClient = (client, onSuccess) => {
			const url = getUrl('AppointmentBook/FullClient');

			const promise = $http.post(url,
				{
					Client: client
				});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}


		restServer.addLock = (entityId, noun, onSuccess) => {
			const url = getUrl('AppointmentBook/Lock');

			const promise = $http.post(url,
				{
					entityId: entityId,
					noun: noun
				});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.deleteLock = (entityId, noun, onSuccess) => {
			const url = getUrl('AppointmentBook/Lock');

			const promise = $http.delete(url,
				{
					params: {
						entityId: entityId,
						noun: noun
					}
				});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getClientAlerts = (clientId, onSuccess) => {
			//const url = getUrl('Alerts/Client/' + clientId);

			//const promise = $http.get(url, {});

			//restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getServiceAlerts = (serviceId, employeeId, onSuccess) => {
			//const url = getUrl('Alerts/Service/' + serviceId + '/' + employeeId);

			//const promise = $http.get(url, {});

			//restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getEmployee = (employeeId, onSuccess) => {
			const url = getUrl(`/Employee/${employeeId}`);

			const promise = $http.get(url, {});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getAppointmentAuditHistory = (appointmentId, appSettings, onSuccess) => {
			const url = getUrl(`Appointment/${appointmentId}/History`);

			let options = {};

			if (appSettings) {
				options = {
					params: {
						locale: appSettings.APP_COUNTRYID,
						timeFormat: appSettings.APP_TIME_FORMAT
					}
				};
			}

			const promise = $http.get(url, options);

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getBlockAuditHistory = (blockId, appSettings, onSuccess) => {
			const url = getUrl(`Block/${blockId}/History`);

			const options = {
				params: {
					locale: appSettings.APP_COUNTRYID,
					timeFormat: appSettings.APP_TIME_FORMAT
				}
			};
			const promise = $http.get(url, options);

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getAppointmentScheduleAuditHistory = (appointmentScheduleId, appSettings, onSuccess) => {
			const url = getUrl(`AppointmentSchedule/${appointmentScheduleId}/History`);

			let options = {};

			if (appSettings) {
				options = {
					params: {
						locale: appSettings.APP_COUNTRYID,
						timeFormat: appSettings.APP_TIME_FORMAT
					}
				};
			}

			const promise = $http.get(url, options);

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getAppointmentServiceCount = (startDateTime, endDateTime, communicationType, communicationMethod, confirmStateFilter, onSuccess) => {

			const url = getUrl('AppointmentClientServices/Count');
			const promise = $http.post(url, {
				criteria: {
					startDateTime: startDateTime,
					endDateTime: endDateTime,
					communicationType: communicationType,
					communicationMethod: communicationMethod,
					confirmStateFilter: confirmStateFilter
				}
			});

			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

        restServer.getAppointmentServiceEquipment = (appointmentService, siblingAppointmentServices, onSuccess) => {
			const url = getUrl(`/AppointmentService/${appointmentService.id || NewGuid()}/EquipmentAvailability/List`);
			// Need to make a copy so that we're not modifying the one the client uses each time resources are retrieved
			var copy = jQuery.extend(true, {}, appointmentService);
            copy.siblings = siblingAppointmentServices;
			const promise = $http.post(url, copy);
            restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getAppointmentServiceResources = (appointmentService, siblingAppointmentServices, onSuccess) => {
			const url = getUrl(`/AppointmentService/${appointmentService.id || NewGuid()}/ResourceAvailability/List`);
			// Need to make a copy so that we're not modifying the one the client uses each time resources are retrieved
			var copy = jQuery.extend(true, {}, appointmentService);
			copy.siblings = siblingAppointmentServices;
			const promise = $http.post(url, copy);
			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.getBlockResources = (block, onSuccess) => {
			let blockId = block.id || emptyGuid();
			const url = getUrl(`/Block/${blockId}/ResourceAvailability/List`);
			const promise = $http.post(url, block);
			restServer.SetOnSuccessAndError(promise, onSuccess);
		}

		restServer.deleteAppointmentRequest = (id, entityVersion, isMissedOpportunity) => {
			const url = getUrl(`/appointmentRequest/${id}`);

			const promise = $http.delete(url, {
				params: {
					entityVersion: entityVersion,
					isMissedOpportunity: isMissedOpportunity
				}
			});
			restServer.SetOnSuccessAndError(promise);
		}

		restServer.patchAppointmentRequest = (id, isArchived, isMissedOpportunity, onSuccess) => {
			const url = getUrl(`/appointmentRequest/${id}`);

			const promise = $http({
				url: url,
				method: 'PATCH',
				data:
				{
					model: {
						IsArchived: isArchived,
						IsMissedOpportunity: isMissedOpportunity
					}
				}
			});
			restServer.SetOnSuccessAndError(promise, onSuccess);
		}


		restServer.LoadPendingAppointmentRequest = () => {
			const url = getUrl('AppointmentBook/PendingAppointmentCount');

			const promise = $http.get(url, {});
			return promise;
		}

		restServer.getRegisterPriceList = (services, applyProductUsage: boolean = false) => {
			const request = {
				applyProductUsage: applyProductUsage,
				applySalePrograms: false,
				applyMemberDiscounts: true,
				applyYieldManagement: _(services).any((service) => service.startDateTime != undefined),
				calculateCharges: true,
				services: services
			};

			const url = getUrl(`Service/RegisterPrice/List`);

			return $http.post(url, request);
		}

		return restServer;

	}
]);
